enum ClientContactType {
    Casting = 0,
    Accounts = 1,
    Other = 2
}

export default ClientContactType;